export default __webpack_public_path__ + "static/210512_更新完成_kr-68461fd79b26c18de396d8fad7241ee8.png";